import type { ClaimRcmStatus } from '../mockClaims';

export const RCM_STATUS_COLORS: Record<ClaimRcmStatus, string> = {
  ready: 'gray',
  submitted: 'blue',
  acknowledged: 'cyan',
  adjudicated: 'green',
  denied: 'red',
  rejected: 'orange',
};

export function rcmStatusLabel(status: ClaimRcmStatus): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}
